import { OTPInput } from 'input-otp';
import React, { useEffect, useState, useContext } from 'react';
import { DashSlotGroup } from 'src/components/easy-setup/modules/components/input/OTPInput';
import  Button  from 'src/components/ui/buttons';
import { InputFieldWithInnerLabel } from 'src/components/ui/inputFields/input-field-with-label';
import { createCompany } from 'src/components/easy-setup/controller';
import { AuthContext } from "../../context/auth/auth_context";
import { BACKGROUND_VIDEO } from "../../shared/config";
import { useGetDistrict, useGetProvince, useGetSubDistrict } from "src/api/site";
import { useLoggedInUser } from "../../api/userInfo";
import PhoneInput from "react-phone-input-2";   
import "react-phone-input-2/lib/style.css";

const InfoDetails = () => {
    const { user } = useLoggedInUser()
    const [taxId, setTaxId] = useState('');
    const [details, setDetails] = useState({
        name: '',
        tax_id: '',
        address: {
            address_no: '',
            building_name: '',
            floor_no: '',
            room_no: '',
            soi: '',
            road_name: '',
            sub_district: '',
        },
        is_head_office: true,
        config: {
            name: '',
            legal_entity: '',
            phone_number: '',
            logo: null, 
            vat_reg: false, 
        },
    });
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [selectedProvinceId, setSelectedProvinceId] = useState(null);
    const [selectedDistrictId, setSelectedDistrictId] = useState(null);
    const [selectedSubDistrictId, setSelectedSubDistrictId] = useState(null);

    const THAILAND_COUNTRY_ID = 1; 
    const { provinceList } = useGetProvince(THAILAND_COUNTRY_ID);
    const { districtList } = useGetDistrict(selectedProvinceId || details?.province);
    const { subDistrictList } = useGetSubDistrict(selectedDistrictId || details?.district);

    const updatedDistrictList = districtList?.map((district) => ({
        ...district,
        label: district?.label?.replace("Khet ", ""),
      }));

    
    const capitalizedProvinceList = provinceList?.map(province => ({
        ...province,
        label: province?.label?.charAt(0)?.toUpperCase() + province?.label?.slice(1), 
    }));
    
    
    useEffect(() => {
        if (selectedProvinceId && selectedProvinceId !== details?.address?.province) {
            setDetails((prevDetails) => ({
                ...prevDetails,
                address: {
                    ...prevDetails.address,
                    province: selectedProvinceId,
                    district: null,       
                    sub_district: null,
                    postal_code: '',
                },
            }));
        }
    
        if (selectedDistrictId && selectedDistrictId !== details?.address?.district) {
            setDetails((prevDetails) => ({
                ...prevDetails,
                address: {
                    ...prevDetails.address,
                    district: selectedDistrictId,
                    postal_code: '',
                },
            }));
        }
    
        if (selectedSubDistrictId && selectedSubDistrictId !== details?.address?.sub_district) {
            const selectedSubDistrict = subDistrictList?.find((item) => item.value === parseInt(selectedSubDistrictId, 10));

            if (selectedSubDistrict) {
                setDetails((prevDetails) => ({
                    ...prevDetails,
                    address: {
                        ...prevDetails.address,
                        sub_district: selectedSubDistrictId,
                        postal_code: selectedSubDistrict?.post_code,
                    },
                }));
            }
        }

    }, [selectedProvinceId, selectedDistrictId, selectedSubDistrictId, subDistrictList]);

  
    const handleProvinceChange = (e) => {
        const selectedId = e.target.value;
        onInputChange("province", selectedId);
        setSelectedProvinceId(selectedId);
        setSelectedDistrictId(null);
        setSelectedSubDistrictId(null);
      };
    
      const handleDistrictChange = (e) => {
        const selectedId = e.target.value;
        onInputChange("district", selectedId);
        setSelectedDistrictId(selectedId);
        setSelectedSubDistrictId(null);
      };
    
      const handleSubDistrictChange = (e) => {
        const selectedId = e.target.value;
        onInputChange("sub_district", selectedId);
        setSelectedSubDistrictId(selectedId);
        
      };
 

    const legal_entityOptions = [
        { value: 'company_limited', label: 'Company limited (บริษัทจำกัด)' },
        { value: 'partnership', label: 'Limited partnership (ห้างหุ้นส่วนจำกัด)' },
        { value: 'association', label: 'Association (สมาคม)' },
      ];

      
   
      const onInputChange = (fieldName) => (e) => {
        // console.log(`${fieldName} changed to:`, e.target.value);
        // if (fieldName in details.address) {
        //     setDetails({
        //         ...details,
        //         address: {
        //             ...details.address,
        //             [fieldName]: e.target.value,
        //         },
        //     });
        // } else {
        //     setDetails({ ...details, [fieldName]: e.target.value });
        // }
        const value = e.target.value;
        setDetails((prevDetails) => {
            if (fieldName === "phone_number") {
                return {
                    ...prevDetails,
                    config: {
                        ...prevDetails.config,
                        phone_number: value, 
                    },
                };
            }
            if (fieldName in prevDetails.address) {
                return {
                    ...prevDetails,
                    address: {
                        ...prevDetails.address,
                        [fieldName]: value,
                    },
                };
            }
            return {
                ...prevDetails,
                [fieldName]: value,
            };
        });
      };

      
      const handleEntityChange = (e) => {
        setDetails((prevData) => ({
          ...prevData,
          config: {
            ...prevData.config,
            legal_entity: e.target.value,
          },
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        const dataToSubmit = {
            name: details?.config?.name || details.name,  
            address: JSON.stringify({ ...details.address }),  
            logo: details?.config?.logo ?? null,
            tax_id: taxId ?? '',
            config: JSON.stringify(details?.config),
            document: JSON.stringify([]),
            doc_file: [],  
            vat_reg: details?.config?.vat_reg,
        };
        
        
        try {
            const response = await createCompany(dataToSubmit);
            if(response?.data){
                
                setLoading(false);
                setSuccess('Company created successfully!');
                window.location.href = '/';
            }
            
        } catch (error) {
            setLoading(false);
            setError('Failed to create company. Please try again.');
        }
    };


    const handleSkip = () => {
        if(user?.is_verified_email){
            window.location.href = '/';
        }else{
            window.location.href = '/verify';
        }
        
          
    };

    
    return (
        <div>
            <video
                autoPlay
                loop
                muted
                className="fixed z-0 w-auto min-w-full min-h-full max-w-none"
            >
                <source src={BACKGROUND_VIDEO} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0  w-auto min-w-full min-h-full opacity-0 bg-vekin max-w-none"></div>
            <div className="absolute inset-0 z-20 flex items-center justify-center w-full h-screen overflow-hidden">
                <div className="p-4  bg-white rounded-md h-50 max-w-fit">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold">Company Information</h2>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <p className="w-full mb-2 text-center">
                                Input your 13-digit tax ID here to continue with the setup process.
                            </p>
                            <OTPInput
                                value={taxId}
                                maxLength={13}
                                containerClassName="group flex items-center has-[:disabled]:opacity-30 justify-center"
                                onChange={(e)=>setTaxId(e)}
                                render={({ slots }) => (
                                <>
                                    <div className="flex gap-2">
                                    <div className="flex gap-2">
                                        <DashSlotGroup slots={slots} start={0} end={1} />
                                        <DashSlotGroup slots={slots} start={1} end={5} />
                                        <DashSlotGroup slots={slots} start={5} end={10} />
                                        <DashSlotGroup slots={slots} start={10} end={13} />
                                    </div>
                                    </div>
                                </>
                                )}
                            />
                        </div>


                        <div className="mb-2 flex gap-2">
                            <InputFieldWithInnerLabel
                                options={legal_entityOptions} 
                                value={details?.config?.legal_entity}
                                onChange={handleEntityChange}
                                name="legal_entity"
                                label="Legal Entity"
                                type="select"
                                className="text-vekin"
                                optionLabel="Please select legal entity"
                            />
                            <InputFieldWithInnerLabel
                                defaultValue={details?.name}
                                name="name"
                                label="Business Name"
                                placeholder="please fill business name"
                                type={"text"}
                                className="text-vekin"
                                onChange={onInputChange("name")}
                                maxLength={120}
                            />

                        </div>

                        <div className="mb-2">
                            <InputFieldWithInnerLabel
                                defaultValue={details?.address?.address_no}
                                onChange={onInputChange("address_no")}
                                name="address"
                                label="Address"
                                type={"text"}
                                className="text-vekin"
                                placeholder={"Please fill address"}
                                maxLength={120}
                            />
                           <div className="grid grid-cols-2 my-2 gap-2">
                                <InputFieldWithInnerLabel
                                    // options={provinceList}
                                    options={capitalizedProvinceList}
                                    value={selectedProvinceId || details?.province }
                                    onChange={handleProvinceChange}
                                    name="province"
                                    label="Province"
                                    type={"select"}
                                    className="text-vekin"
                                    optionLabel={"please select province"}
                                />
                                

                                <InputFieldWithInnerLabel
                                    options={updatedDistrictList}
                                    defaultValue={selectedDistrictId || details?.district }
                                    onChange={handleDistrictChange}
                                    name="district"
                                    label="District"
                                    type={"select"}
                                    className="text-vekin"
                                    optionLabel={"please select district"}
                                />

                                <InputFieldWithInnerLabel
                                    options={subDistrictList}
                                    defaultValue={selectedSubDistrictId || details?.sub_district }
                                    onChange={handleSubDistrictChange}
                                    name="sub_district"
                                    label="Sub District"
                                    type={"select"}
                                    className="text-vekin"
                                    optionLabel={"please select subdistrict"}
                                /> 

                                {/* <InputFieldWithInnerLabel
                                    defaultValue={details?.address?.postal_code}
                                    onChange={onInputChange("postal_code")}
                                    name="postal_code"
                                    label="Postal Code"
                                    type={"number"}
                                    className="text-vekin"
                                    placeholder={"please fill postal code"}
                                    disabled={details?.address?.postal_code || !details?.address?.postal_code}
                                /> */}

                                <div className='relative w-full mt-1'>
                                    <input 
                                    defaultValue={details?.address?.postal_code}
                                    disabled={details?.address?.postal_code || !details?.address?.postal_code}
                                    onChange={onInputChange("postal_code")}
                                    type="text" 
                                    name="postal_code"
                                    placeholder={"please fill postal code"}
                                    className={"rounded-md disabled text-primary pt-5 pb-2 border read-only:border-1 read-only:cursor-not-allowed disabled:text-slate-500 border-gray-300 peer flex-1 block w-full pl-2 text-sm outline-none col-span-2 " }
                                    />
                                    <label className="absolute  text-xs capitalize bg-white left-2  text-slate-500 top-1">Postal Code</label>
                                </div>
                            </div>
                        </div>

                        <div className="relative ">
                            {/* <InputFieldWithInnerLabel
                                defaultValue={details?.config?.phone_number}
                                onChange={onInputChange("phone_number")}
                                name="phone_number"
                                label="Phone number"
                                placeholder="fill phone number"
                                type={"number"}
                                className="text-vekin"
                            /> */}
                            <label className="text-primary text-xs capitalize absolute left-12 mt-0.5 z-50" htmlFor="phone">Phone number</label>
                            <PhoneInput
                                country={"th"}
                                value={details?.config?.phone_number}
                                onChange={(phone_number) => onInputChange("phone_number")({ target: { value: phone_number } })}
                                countryCodeEditable={false}
                                placeholder="Enter phone number"
                                inputProps={{
                                name: "phone",
                                required: true,
                                autoFocus: false,
                                maxLength: 15,
                                }}
                                // className="w-full border border-gray-200 rounded-lg focus:border-vekin"
                                inputStyle={{
                                    width: "100%",
                                    height: "50px", 
                                    fontSize: "14px", 
                                    borderRadius: "6px", 
                                    // outline: "1px solid #1FA37C",
                                    // outline: "none",
                                    border: "1px solid #ccc",
                                    paddingTop: "14px"
                                }}
                                containerStyle={{
                                    width: "100%", 
                                }}
                                focusStyle={{
                                    outline: "1px solid #1FA37C", 
                                }}
                            />
                        </div>


                        <div className="flex justify-between p-4 w-full">
                            <Button
                                type="button"
                                onClick={handleSkip}
                                danger
                            >
                                skip
                            </Button>
                            <Button primary type="submit">
                                submit
                            </Button>
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default InfoDetails;